module.exports = __webpack_public_path__ + "static/WTC-846d8b2e4bc25b86839e8b0b90a1c6e3.gif";